import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
// import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import { callPhotoDeletionByKeyAsync } from "../../../../apis/photos";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
export const onDeletePhoto = (photo) => {
    return callPhotoDeletionByKeyAsync(photo.key).then(() => {
        photosStore.setPhotos(photosStore.getPhotos()
            .map(photos => photos.filter(i => i.key !== photo.key))
            .filter(photos => photos.length !== 0));
    });
};
export const PhotoCard = ({ photo }) => {
    return (_jsxs(Card, { sx: { maxWidth: 345, width: 300 }, children: [_jsxs(CardActionArea, { children: [_jsx(CardMedia, { component: "img", height: "300", image: photo.url, alt: 'failed to load image' }, void 0), _jsx(CardContent, {}, void 0)] }, void 0), _jsx(CardActions, { children: _jsx(Button, { size: "small", color: "primary", onClick: () => onDeletePhoto(photo), children: "Delete" }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=PhotoCard.js.map